export default __webpack_public_path__ + "static/media/logo2.f2fee8d9.png";